import { render } from "./limit-dialog-view.vue?vue&type=template&id=1d56907e&scoped=true&ts=true"
import script from "./limit-dialog-view.vue?vue&type=script&lang=ts"
export * from "./limit-dialog-view.vue?vue&type=script&lang=ts"

import "./limit-dialog-view.vue?vue&type=style&index=0&id=1d56907e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d56907e"]])

export default __exports__